import { FC } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { View } from './components/View';

const NotificacionDetallePage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Oportunidad</PageTitle>
      <View />
    </>
  );
};

export { NotificacionDetallePage };
